var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.40751 17.7269C4.90528 17.7269 4.44232 17.4715 4.18419 17.0522C3.86713 16.5302 3.96814 15.861 4.41988 15.4529L5.69651 14.3034V9.66098C5.69932 6.11253 8.6931 3 12.1021 3C15.5112 3 18.5049 6.11253 18.5049 9.66098V14.3034L19.7816 15.4529C20.2361 15.861 20.3343 16.533 20.0173 17.0522C19.7619 17.4687 19.2962 17.7269 18.7939 17.7269H5.40751Z",
    stroke: "#242628",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6458 17.7993C15.6458 19.7485 14.0605 21.3256 12.1049 21.3256C10.1492 21.3256 8.56396 19.7457 8.56396 17.7993H15.6486H15.6458Z",
    stroke: "#242628",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBell);
export default __webpack_public_path__ + "static/media/ico-bell.c53cda9ed8e48dff49e54e1b3abd5400.svg";
export { ForwardRef as ReactComponent };